<template>
  <div class="p-report-download-list__item">
    <div class="p-report-download-list__header">
      <TitleSub level="h4">
        {{ item.yearMonth | dateText('YYYY年MM月') }} 月間サイト分析レポート
      </TitleSub>
      <p class="c-text--note">
        対象期間: {{ from | dateText('YYYY年MM月DD日') }}～{{
          to | dateText('YYYY年MM月DD日')
        }}まで
      </p>
    </div>
    <p class="p-report-download-list__status" :class="{ 'is-get': item.isGet }">
      {{ item.isGet ? 'ダウンロード済み' : '未ダウンロード' }}
    </p>
    <ButtonDownload
      :isDisabled="isProcessing"
      :isLoading="isProcessing"
      @click="download"
    />
  </div>
</template>

<script>
import ButtonDownload from '@/components/reportDownload/ButtonDownload';
import TitleSub from '@/components/TitleSub';
import apiProjects from '@/api/projects';
import utils from '@/utils';

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    project: {
      type: Object,
      required: true
    }
  },
  components: {
    ButtonDownload,
    TitleSub
  },
  data() {
    return {
      isProcessing: false
    };
  },
  computed: {
    from() {
      return utils.getStartDate(this.item.yearMonth, 'month');
    },
    to() {
      return utils.getEndDate(this.item.yearMonth, 'month');
    }
  },
  methods: {
    download() {
      if (this.isProcessing) {
        return;
      }
      this.isProcessing = true;

      apiProjects.monthlyReports.download
        .get(this.auth.idToken, this.project.id, this.item.id)
        .then(response => {
          const date = utils.formatDate(this.item.yearMonth, 'YYYY年MM月');
          // ファイルが別ドメインにある場合、fileNameは無視される
          const fileName = `月間サイト分析レポート_${date}_${this.project.name}.pptx`;
          utils.downloadUrl(response.data.url, fileName);
          this.$emit('download');
          this.isProcessing = false;
        })
        .catch(error => {
          this.isProcessing = false;
        });
    }
  }
};
</script>
